import { BackgroundFacet, BackgroundSource, BackgroundTier } from "@/services/bedrock/dtos/BackgroundAsset";

/** Chip titles for the picker's filters and the admin library. */
export const FACET_TITLES: Record<BackgroundFacet, string> = {
  setting: "Setting",
  region: "Landscape",
  occasion: "Occasion",
  season: "Season",
  timeOfDay: "Time of day",
  mood: "Mood",
  palette: "Palette",
  emptySpace: "Empty space",
};

export const SOURCE_TITLE = "Source";
export const TIER_TITLE = "Tier";

export const SOURCE_LABELS: Record<BackgroundSource, string> = {
  generated: "Generated",
  uploaded: "Uploaded",
  stock: "Stock",
};

export const TIER_LABELS: Record<BackgroundTier, string> = {
  quality: "Quality",
  fast: "Fast",
};

// Each image model is one tier; admins see the tier, never the model name. The queue reports
// models camelCased, versions snake_cased.
const MODEL_TIERS: Record<string, BackgroundTier> = { flash: "quality", flash_lite: "fast", flashLite: "fast" };

/** "Quality" or "Fast" for an image model name; null for anything unknown. */
export function modelTierLabel(model: string | null | undefined): string | null {
  const tier = model ? MODEL_TIERS[model] : undefined;
  return tier ? TIER_LABELS[tier] : null;
}

// Values whose plain humanized form would misspell a name.
const LABEL_OVERRIDES: Record<string, string> = {
  pacific_northwest: "Pacific Northwest",
  new_year: "New Year",
  valentines: "Valentine's Day",
};

/** "home_exterior" → "Home exterior", "golden_hour" → "Golden hour". */
export function facetLabel(_facet: BackgroundFacet, value: string): string {
  const override = LABEL_OVERRIDES[value];
  if (override) return override;
  const words = value.replace(/_/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}
